module.exports = __webpack_public_path__ + "img/f3.0c59fa12.png";